/* eslint-disable @stylistic/max-statements-per-line */
import type React from 'react';

import type { Emotions } from '@vlabs/api/luna-api/model';
import { useTranslation } from 'react-i18next';

interface EmotionsValueProps {
  emotions?: Emotions;
}

function EmotionsValue({
  emotions = undefined,
}: EmotionsValueProps): React.ReactNode {
  const { t } = useTranslation();
  const predominantEmotion = emotions?.predominant_emotion;
  if (!predominantEmotion) return '-';

  let value;

  // eslint-disable-next-line default-case
  switch (predominantEmotion) {
    case 'anger': { value = t('constants:anger'); break; }
    case 'disgust': { value = t('constants:disgust'); break; }
    case 'fear': { value = t('constants:fear'); break; }
    case 'happiness': { value = t('constants:happiness'); break; }
    case 'sadness': { value = t('constants:sadness'); break; }
    case 'surprise': { value = t('constants:surprise'); break; }
    case 'neutral': { value = t('constants:neutral'); break; }
  }

  return (
    <div>{value}</div>
  );
}

export { EmotionsValue };
